import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Globe = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 2C8.275 2 2 8.275 2 16C2 23.725 8.275 30 16 30C23.725 30 30 23.725 30 16C30 8.275 23.725 2 16 2ZM16 28C14.85 28 13.375 25.812 12.575 22H19.425C18.625 25.813 17.15 28 16 28V28ZM12.238 20C12.088 18.788 12 17.45 12 16C12 14.55 12.088 13.213 12.238 12H19.75C19.9 13.213 19.988 14.55 19.988 16C19.988 17.45 19.901 18.788 19.75 20H12.238ZM4 16C4 14.6 4.237 13.25 4.688 12H10.251C10.089 13.313 10.013 14.662 10.013 16C10.013 17.338 10.101 18.688 10.251 20H4.688C4.238 18.75 4 17.4 4 16ZM16 4C17.15 4 18.625 6.188 19.425 10H12.575C13.375 6.187 14.85 4 16 4ZM21.762 12H27.312C27.762 13.25 28 14.6 28 16C28 17.4 27.762 18.75 27.312 20H21.749C21.912 18.687 21.987 17.337 21.987 16C21.999 14.662 21.912 13.312 21.762 12ZM26.387 10H21.437C21.024 7.875 20.387 5.963 19.537 4.537C22.45 5.437 24.887 7.412 26.387 10ZM12.45 4.537C11.6 5.962 10.962 7.875 10.563 10H5.613C7.113 7.412 9.551 5.437 12.45 4.537ZM5.612 22H10.562C10.974 24.125 11.612 26.038 12.462 27.462C9.55 26.562 7.112 24.587 5.612 22V22ZM19.55 27.462C20.4 26.037 21.038 24.125 21.437 22H26.387C24.887 24.587 22.449 26.563 19.549 27.462H19.55Z" />
	</svg>
);

export default Globe;
